// extracted by mini-css-extract-plugin
export default {"button":"continue-button_button__IZDUz"};